import { Card, CardContent, Box, Typography, Avatar } from "@mui/material";
import MUITypography from "../../Components/MUITypography";

export const AnalyticsCard = ({
  title,
  value,
  icon,
  iconColor,
  onClick,
}) => {
  return (
    <Card
      variant="outlined"
      onClick={onClick}
      sx={{
        borderRadius: 2,
        // height: "100%",
        cursor: onClick ? "pointer" : "default",
        transition: "0.2s",

        /* 🔑 FIXES */
        // minWidth: { xs: "100%", sm: "14rem" },

        // "&:hover": onClick
        //   ? {
        //       boxShadow: 1,
        //       transform: "translateY(-2px)",
        //     }
        //   : {},
      }}
    >
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box>
            <MUITypography variant="body2">
              {title}
            </MUITypography>

            <Typography sx={{ fontSize: "2rem", fontWeight: 600 }}>
              {value}
            </Typography>
          </Box>

          <Avatar src={icon} sx={{ bgcolor: iconColor, width: "2rem", height: "2rem" }}>
            {/* <Icon size={18} color="white" /> */}
          </Avatar>
        </Box>
      </CardContent>
    </Card>
  );
};

